import { EnhancedRouteProps } from 'router/routes/Enhanced/Enhanced.route';
import EnterpisesList from './pages/EntrprisesList';
import AddEnterprise from './pages/AddEnterprise';
import EnterpriseRouter from './subrouters/Enterprise';
import enterpriseRoutes from './subrouters/Enterprise/routes';

export default [
  {
    path: 'add',
    element: AddEnterprise,
  },
  {
    path: ':id',
    element: EnterpriseRouter,
    routes: enterpriseRoutes,
  },
  { index: true, element: EnterpisesList },
] as Array<EnhancedRouteProps>;
